import React, { useEffect, useState, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import httpService from "../../services/httpService";
import { fetchAuthSession } from "aws-amplify/auth";
import config from "../../config";
import "./CriteriaManagement.css";

const CriteriaDetails = ({ criteriaId, criteriaName, onCriteriaDeleted }) => {
  const navigate = useNavigate();
  const [drivingTime, setdrivingTimeData] = useState([]);
  const [hierarchy, setHierarchyData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const toast = useRef(null);

  const fetchCriteriaDetails = async () => {
    if (criteriaId) {
      setLoading(true);

      const session = await fetchAuthSession();
      const token = session.tokens.idToken;

      httpService
        .post(
          process.env.REACT_APP_CRITERIA_MGMT_LAMBDA_PATH,
          {
            operationType: "ProviderDetails",
            id_criteria: criteriaId,
          },
          token
        )
        .then((response) => {
          console.log(response.data);
          const DrivingTimeData = response.data.TimeAndDistance.map((item) => ({
            CountyCode: item.countycode,
            County: item.county,
            Type: item.countytype,
            Zone: item.regionname,
            MinimumProviders: item.minproviders,
            DrivingTime: item.tme_drve,
            Distance: item.distance,
          }));
          const HierarchyData = response.data.Hierarchies.map((item) => ({
            providerCode: item.providerCode,
            providerType: item.provider,
            primarySpecialtyCode: item.cde_speclty_prim,
            primarySpecialty: item.type_speclty_prim,
          }));
          setdrivingTimeData(DrivingTimeData);
          setHierarchyData(HierarchyData);
        })
        .catch((error) => {
          console.error("Error fetching Provider Details:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchCriteriaDetails();
  }, [criteriaId]);

  const drivingTimeData = [
    ...drivingTime.map((item) => ({
      CountyCode: item.CountyCode,
      County: item.County,
      Type: item.Type,
      Zone: item.Zone,
      MinimumProviders: item.MinimumProviders,
      DrivingTime: item.DrivingTime,
      Distance: item.Distance,
    })),
  ];

  const providerHierarchyData = [
    ...hierarchy.map((item) => ({
      providerCode: item.providerCode,
      providerType: item.providerType,
      primarySpecialtyCode: item.primarySpecialtyCode,
      primarySpecialty: item.primarySpecialty,
    })),
  ];

  const onDelete = async (criteriaId) => {
    const session = await fetchAuthSession();
    const token = session.tokens.idToken;
    httpService
      .post(
        process.env.REACT_APP_CRITERIA_MGMT_LAMBDA_PATH,
        {
          operationType: "DeleteCriteria",
          criteria_id: criteriaId,
        },
        token
      )
      .then((response) => {
        console.log(response.data);
        toast.current.show({
          severity: "warn",
          summary: "Success",
          detail: "Criteria has been deleted successfully.",
          life: 3000,
        });
        if (onCriteriaDeleted) {
          onCriteriaDeleted();
        }
      })
      .catch((error) => {
        console.error("Error deleting criteria:", error);
        toast.current.show({
          severity: "Error",
          summary: "Failed",
          detail: "Error deleting criteria. Please try again.",
          life: 3000,
        });
      });
    console.log("Deleting criteria with ID:", criteriaId);
  };

  const confirmDelete = (criteriaId) => {
    confirmDialog({
      message: "Do you wish to delete the selected provider criteria?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => onDelete(criteriaId),
      reject: () => {},
    });
  };

  const handleMinimumProvidersButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/criteriamanagement/editminimumproviders", {
      state: { criteriaId, criteriaName },
    });
  };

  const handleProviderHierarchyButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/criteriamanagement/edithierarchy", {
      state: { criteriaId, criteriaName },
    });
  };

  if (!criteriaId) {
    return null;
  }

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Card
          title={criteriaName
            .toUpperCase()
            .toLowerCase()
            .replace(/\b\w/g, (l) => l.toUpperCase())}
          style={{ border: "none", boxShadow: "none"}}
        />
        {config.FEATURE_FLAGS.CRITERIA_MANAGEMENT.deleteCriteria && (
          <Button
            label="Delete"
            icon="pi pi-trash"
            severity="danger"
            onClick={() => confirmDelete(criteriaId)}
            size="small"
            style={{ margin: "10px 0px 10px 0", width: "100px" }}
          />
        )}
      </div>
      <div>
        <Accordion multiple>
          <AccordionTab
            header={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: "17px" }}>Requirements</p>
                <Button
                  label="Edit"
                  className="button-edit"
                  onClick={handleMinimumProvidersButtonClick}
                />
              </div>
            }
          >
            <DataTable
              value={drivingTimeData}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 15]}
              loading={isLoading}
            >
              <Column
                field="CountyCode"
                header="County Code"
                alignHeader={"center"}
                align={"center"}
                sortable
              />
              <Column
                field="County"
                header="County"
                alignHeader={"center"}
                align={"center"}
                sortable
              />
              <Column
                field="Type"
                header="Type"
                alignHeader={"center"}
                align={"center"}
                sortable
              />
              {/* <Column
                field="Zone"
                header="Zone"
                alignHeader={"center"}
                align={"center"}
                sortable
              /> */}
              <Column
                field="MinimumProviders"
                header="Minimum Providers"
                alignHeader={"center"}
                align={"center"}
              />
              <Column
                field="DrivingTime"
                header="Time (mins)"
                alignHeader={"center"}
                align={"center"}
              />
              <Column
                field="Distance"
                header="Distance (mi)"
                alignHeader={"center"}
                align={"center"}
              />
            </DataTable>
          </AccordionTab>

          {config.FEATURE_FLAGS.CRITERIA_MANAGEMENT.showHierarchy && (
            <AccordionTab
              header={
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p style={{ fontSize: "17px" }}>Provider Hierarchy</p>
                  <Button
                    label="Edit"
                    className="button-edit"
                    onClick={handleProviderHierarchyButtonClick}
                  />
                </div>
              }
            >
              <DataTable
                value={providerHierarchyData}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10]}
                loading={isLoading}
              >
                <Column
                  field="providerType"
                  header="Provider Type"
                  alignHeader={"center"}
                  align={"center"}
                />
                <Column
                  field="primarySpecialty"
                  header="Primary Specialty"
                  alignHeader={"center"}
                  align={"center"}
                />
              </DataTable>
            </AccordionTab>
          )}
        </Accordion>
        <ConfirmDialog />
      </div>
    </>
  );
};

export default CriteriaDetails;
